import { ClockIcon, InstagramIcon, LocationIcon, LogoIcon, MailIcon } from '@/assets/icons'
import { Link } from 'react-router-dom'

export default function Footer() {
	return (
		<div className="grid grid-cols-2 max-lg:gap-8 lg:grid-cols-5 justify-between items-start pt-8 lg:pt-10 pb-8 px-5">
			<div className="max-lg:hidden flex items-center gap-2">
				<LogoIcon className="size-12 2xl:size-16 shrink-0" />
				<div className="flex flex-col gap-1">
					<h2 className="text-secondary text-base 2xl:text-xl font-extrabold">minmini</h2>
					<p className="text-muted-foreground max-2xl:text-sm font-medium lg:w-10/12">
						(Ver)kaufe nachhaltig, schaffe Platz und verdiene dabei.&quot;
					</p>
				</div>
			</div>
			<div className="flex flex-col gap-4 lg:gap-6">
				<h2 className="text-secondary lg:text-base 2xl:text-xl font-extrabold">
					Wichtige Informationen
				</h2>
				<Link
					to="/kontakt"
					className="text-muted-foreground text-xs lg:text-sm 2xl:text-base font-medium">
					Impressum
				</Link>
				<Link
					to="/letter"
					className="text-muted-foreground text-xs lg:text-sm 2xl:text-base font-medium">
					AGB
				</Link>
				<Link
					to="/widerruf"
					className="text-muted-foreground text-xs lg:text-sm 2xl:text-base font-medium">
					Widerruf
				</Link>
				<Link
					to="/datenschutz"
					className="text-muted-foreground text-xs lg:text-sm 2xl:text-base font-medium">
					Datenschutz
				</Link>
				<Link
					to="/faqs"
					className="text-muted-foreground text-xs lg:text-sm 2xl:text-base font-medium">
					FAQ
				</Link>
			</div>
			<div className="flex flex-col gap-4 lg:gap-6">
				<h2 className="text-secondary lg:text-xl invisible font-extrabold">Schnellzugriff</h2>
				<Link to="/" className="text-muted-foreground text-xs lg:text-sm 2xl:text-base font-medium">
					Startseite
				</Link>
				<Link
					to="/customer/regal-mieten"
					className="text-muted-foreground text-xs lg:text-sm 2xl:text-base font-medium">
					Regal Mieten
				</Link>
				<Link
					to="https://www.minmini-shop.de/"
					target="__blank"
					className="text-muted-foreground text-xs lg:text-sm 2xl:text-base font-medium">
					minmini Shop
				</Link>
				<Link
					to="/kontakt"
					className="text-muted-foreground text-xs lg:text-sm 2xl:text-base font-medium">
					Kontakt
				</Link>
			</div>
			<div className="flex max-lg:col-span-2 flex-col gap-5 lg:gap-8">
				<div className="flex items-center gap-3">
					<LocationIcon className="size-8 2xl:size-10 shrink-0" />
					<p className="text-secondary font-extrabold text-xs 2xl:text-sm">
						Kieler Str. 113 <br />
						24119 Kronshagen
					</p>
				</div>
				<div className="flex items-center gap-3">
					<MailIcon className="size-8 2xl:size-10 shrink-0" />
					<div className="flex flex-col gap-1 text-xs 2xl:text-sm">
						<p className="flex flex-wrap gap-1.5">
							<span className="text-secondary">Allgemeine Anfragen:</span>
							<span className="text-secondary font-extrabold">support@minmini.de</span>
						</p>
						<p className="flex flex-wrap gap-1.5">
							<span className="text-secondary">Geschäftliche Anfragen:</span>
							<span className="text-secondary font-extrabold">info@minmini.de</span>
						</p>
					</div>
				</div>
				<div className="flex items-start gap-3">
					<ClockIcon className="size-8 2xl:size-10 shrink-0 mt-0.5" />
					<div className="flex flex-col gap-0.5 text-secondary font-extrabold text-xs 2xl:text-sm">
						<div className="flex gap-2">
							<span className="w-[16ch] shrink-0">Montag - Freitag:</span>
							<div className="flex flex-col">
								<span>10:00 - 13:00 Uhr</span>
								<span>14:00 - 18:00 Uhr</span>
							</div>
						</div>
						<div className="flex gap-2">
							<span className="w-[16ch] shrink-0">Samstag:</span>
							<span>10:00 - 15:00 Uhr</span>
						</div>
					</div>
				</div>
				<Link
					to="https://www.instagram.com/minmini.kidsstore"
					target="__blank"
					className="flex lg:hidden items-center gap-3">
					<InstagramIcon className="size-8 2xl:size-10 shrink-0" />
					<p className="text-secondary font-extrabold text-xs 2xl:text-sm">
						Nichts mehr verpassen - <br /> folge uns auf Instagram
					</p>
				</Link>
			</div>
			<Link
				to="https://www.instagram.com/minmini.kidsstore"
				target="__blank"
				className="flex max-lg:hidden items-center gap-3">
				<InstagramIcon className="size-8 2xl:size-10 shrink-0" />
				<p className="text-secondary font-extrabold text-xs 2xl:text-sm">
					Nichts mehr verpassen - <br /> folge uns auf Instagram
				</p>
			</Link>
		</div>
	)
}
